import React, { useState } from 'react';
import { Button, Typography, Space, Divider } from 'antd';
import styled from 'styled-components';
import { EyeOutlined } from '@ant-design/icons';
import AuthModal from '../auth/AuthModal';

const { Title, Paragraph } = Typography;

const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
  background: #fff;
`;

const WelcomeTitle = styled(Title)`
  margin-bottom: 1.5rem !important;
`;

const WelcomeDescription = styled(Paragraph)`
  font-size: 1.1rem;
  color: #475569;
  margin-bottom: 2rem;
  max-width: 600px;
`;

const ButtonGroup = styled(Space)`
  margin-bottom: 1rem;
`;

const StyledDivider = styled(Divider)`
  min-width: 200px;
  max-width: 300px;
  margin: 2rem 0;
  color: #94a3b8;
  
  &.ant-divider-horizontal.ant-divider-with-text {
    border-top-color: #e2e8f0;
  }
`;

interface WelcomeViewProps {
  onGuestMode: () => void;
}

const WelcomeView: React.FC<WelcomeViewProps> = ({ onGuestMode }) => {
  const [authModalVisible, setAuthModalVisible] = useState(false);
  const [authModalTab, setAuthModalTab] = useState<'login' | 'register'>('login');

  const handleAuthSuccess = () => {
    // 登录/注册成功后刷新页面数据
    window.location.reload();
  };

  return (
    <WelcomeContainer>
      <WelcomeTitle level={2}>欢迎使用来创业（LetStartUp）</WelcomeTitle>
      <WelcomeDescription>
        登录后即可开始创建你的第一个项目，我们将帮助你一步步实现创业目标。
      </WelcomeDescription>
      <ButtonGroup>
        <Button 
          type="primary" 
          size="large" 
          onClick={() => {
            setAuthModalTab('login');
            setAuthModalVisible(true);
          }}
        >
          立即登录
        </Button>
        <Button 
          size="large" 
          onClick={() => {
            setAuthModalTab('register');
            setAuthModalVisible(true);
          }}
        >
          免费注册
        </Button>
      </ButtonGroup>
      <StyledDivider plain>或者</StyledDivider>
      <Button 
        icon={<EyeOutlined />}
        size="large"
        onClick={onGuestMode}
      >
        以游客模式查看工具集
      </Button>

      <AuthModal
        visible={authModalVisible}
        onClose={() => setAuthModalVisible(false)}
        defaultTab={authModalTab}
        onSuccess={handleAuthSuccess}
      />
    </WelcomeContainer>
  );
};

export default WelcomeView; 